/**
 * @generated SignedSource<<bed6f155b81d98ee7311b8cb727016d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GivePointsToPanelistModal_panelist$data = {
  readonly id: string;
  readonly person: {
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly " $fragmentType": "GivePointsToPanelistModal_panelist";
};
export type GivePointsToPanelistModal_panelist$key = {
  readonly " $data"?: GivePointsToPanelistModal_panelist$data;
  readonly " $fragmentSpreads": FragmentRefs<"GivePointsToPanelistModal_panelist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GivePointsToPanelistModal_panelist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PersonNode",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PanelistNode",
  "abstractKey": null
};

(node as any).hash = "16af238bb6028dd054d8fbfddc77cf5a";

export default node;
